import { I18nNamespace } from "@hopper-b2b/types";

/**
 * Create a local bundle fallback of the shape { en: { localBundleFallback: { key1: copy1, ... }}, pt: { localBundleFallback: { key1: copy1, ... }}}
 * @param generatedTranslations
 * @param tenantTranslation
 * @param englishStrings
 */
const getLocalBundleFallback = (
  generatedTranslations,
  tenantTranslation,
  englishStrings
) => {
  const formattedTranslations = {};
  if (generatedTranslations) {
    // Generated translation has the shape: { en: { translation: {...}}}
    for (const lang in generatedTranslations) {
      formattedTranslations[lang] = {
        [I18nNamespace.localBundleFallback]:
          generatedTranslations[lang][I18nNamespace.translation],
      };
    }
  } else if (tenantTranslation) {
    // Already in the shape we need, see apps/commbank-au/config/translation.ts as an example
    for (const lang in tenantTranslation) {
      formattedTranslations[lang] = {
        [I18nNamespace.localBundleFallback]: tenantTranslation[lang],
      };
    }
  } else if (englishStrings) {
    // Untranslated portal behavior
    formattedTranslations["en"] = {
      [I18nNamespace.localBundleFallback]: englishStrings,
    };
  }
  return formattedTranslations;
};

export default getLocalBundleFallback;
